// biome-ignore lint/style/useNodejsImportProtocol: this is actually importing a shim of the Node.js builtin
import { createHash } from 'crypto';
import { type EdgeId, type NodeId, type NodeSn, brand } from '@ipfabric/utils';
import type { CollapsedNodeGroupId } from 'components/Graph/model/GraphData';
import { array } from 'fp-ts';
import { ordString } from 'fp-ts/lib/Ord';
import { pipe } from 'fp-ts/lib/function';
import { createCounter } from 'utils/number/counter';

export const COLLAPSE_ID_PREFIX = 'collapse/';

const getNextCollapseEdgeNumber = createCounter();

const prefixCollapseId = (idBase: string | number) =>
  `${COLLAPSE_ID_PREFIX}${idBase}`;

export const getNextCollapseEdgeId = (): EdgeId =>
  brand<EdgeId>(prefixCollapseId(getNextCollapseEdgeNumber()));

/**
 * Collapsed group has sn === id
 */
export const getCollapsedGroupId = (
  nodeSnsToCollapse: NodeSn[],
): CollapsedNodeGroupId =>
  brand<CollapsedNodeGroupId>(
    pipe(
      nodeSnsToCollapse,
      array.sort(ordString),
      array.reduce(createHash('md5'), (hash, sn) => hash.update(sn)),
      (hash) => hash.digest('hex'),
      prefixCollapseId,
    ),
  );

export function isCollapsedEntityId(
  entityId: NodeId,
): entityId is CollapsedNodeGroupId;
export function isCollapsedEntityId(entityId: NodeId | EdgeId): boolean;
export function isCollapsedEntityId(entityId: NodeId | EdgeId): boolean {
  return entityId.startsWith(COLLAPSE_ID_PREFIX);
}
